
<template>
    <div>    
        <!--THEME SELECTOR : Theme options are predefined and the user selects one.-->
        <label class="control-label">Theme</label>
            {{ pieceOptions.instructions }}

        <div class="themes d-flex flex-wrap">
            <label v-for="(image_url,index) in (pieceOptions && pieceOptions.themes).split(',')" :key="index" class="p-2 w-25">
                <input type="radio" class="d-none" :name="'pieces[' + pieceIndex + '][content]'"  :value="index+1" :data-img-src="image_url" :checked="index+1 === parseInt(escapeHtml(stripSlashes(pieceContent)))" />

                <img :src="image_url" />
            </label>
        </div>
        <div class="step-spacer"></div>
    </div>
</template>

<script>

    import utils from "../../../../mixins/utils";

    export default {
        name: 'theme-piece',
        mixins: [utils],
        props: {
            pieceIndex: {
                type: Number,
                required:true
            },
            pieceName: {
                type: String,
                required:true
            },
            pieceContent: {
                type: String,
                required:true
            },
            pieceOptions: {
                type: Object,
                required:true
            },
            pieceData: {
              type: Object,
              required:true
            },
        }
    }
</script>

<style lang="scss">

    .themes {
        label {
            input:checked + img {
                box-shadow: 0 0 0 5px #66CCCC;
                border-radius: 1px;
            }
        }
    }
</style>    